import { PROCESS_ACTION_ROUTES_PATH } from '@/constants/process.constatns.js'
import { download, openFile } from '@/services/file.service.js'

export const Processes = axios => ({
  list (filters = {}) {
    const params = this._preparedFilter(filters)
    return axios.get('/v1/processes', { params })
  },
  statuses (filters = {}) {
    const params = this._preparedFilter(filters)
    delete params.statuses

    return axios.get('/v1/processes/statuses', { params })
  },
  _preparedFilter (filters) {
    const params = { ...filters }
    params.keywords = params?.keywords?.map(_ => _.slug)
    params.sales = params?.sales?.map(_ => _.slug)
    params.management_consultants = params?.management_consultants?.map(_ => _.slug)
    params.responsible = params?.responsible?.map(_ => _.slug)
    params.recruiters = params?.recruiters?.map(_ => _.slug)
    params.markets = params?.markets?.map(_ => _.slug)
    params.profiles = params?.profiles?.map(_ => _.slug)
    params.companies = params?.companies?.map(_ => _.slug)
    params.candidate_rejected = params?.candidate_rejected?.map(_ => _.slug)
    params.company_rejected = params?.company_rejected?.map(_ => _.slug)
    return params
  },
  getProfile (processSlug) {
    return axios.get(`/v1/processes/${processSlug}/profile`)
  },
  otherForProfile (processSlug) {
    return axios.get(`/v1/processes/${processSlug}/other-for-profile`)
  },
  create (payload) {
    const params = { ...payload }
    params.profiles = params?.profiles?.map(_ => _.slug)
    params.vacancies = params?.vacancies?.map(_ => _.slug)

    return axios.post('/v1/processes', params)
  },
  getEmailTemplate (template) {
    return axios.get('/v1/processes/email-template', template)
  },
  changeStatus (processSlug, status, payload) {
    const params = { ...payload }
    params.action = params.action?.slug
    if (params.date && params.time) {
      params.date = params.date + ' ' + params.time
      delete params.time
    }
    if (params.company_contact) {
      params.company_contact = params.company_contact.slug
    }

    return axios.put(`/v1/processes/${processSlug}/status/${status}`, params)
  },
  onlyChangeStatus (processSlug, status) {
    return axios.put(`/v1/processes/${processSlug}/status-only/${status}`)
  },
  sendEmailWithTemplate (actionSlug, params) {
    const actionPath = PROCESS_ACTION_ROUTES_PATH[actionSlug]
    return axios.post(`/v1/processes/${actionPath}`, params)
  },
  aggregates: {
    offeredProcesses (categories) {
      categories = categories.map(_ => _.slug)
      return axios.get('/v1/processes/aggregates/offered-count-by-months', {
        params: {
          categories
        }
      })
    },
    lastProcesses (categories) {
      categories = categories.map(_ => _.slug)
      return axios.get('/v1/processes/aggregates/last-offered', {
        params: {
          categories
        }
      })
    }
  },
  interview: {
    approve (processSlug, dateSuggestion, note = null) {
      return axios.put(`/v1/processes/${processSlug}/interview/approve`, {
        note,
        date_suggestion: dateSuggestion
      })
    },
    refuse (processSlug, note = null) {
      return axios.put(`/v1/processes/${processSlug}/interview/refuse`, { note })
    },
    reSuggest (processSlug, dateSuggestions, note = null) {
      return axios.put(`/v1/processes/${processSlug}/interview/re-suggest`, {
        note,
        date_suggestions: dateSuggestions
      })
    }
  },
  candidate: {
    public: {
      accept (processSlug, vacancySlug, profileSlug) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/candidate-accept`)
      },

      reject (processSlug, vacancySlug, profileSlug, payload) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/candidate-reject`, payload)
      },

      sendFeedback (processSlug, vacancySlug, profileSlug, payload) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/profiles/chats/messages`, payload)
      }
    },

    accept (processSlug) {
      return axios.put(`/v1/processes/${processSlug}/candidate-accept`)
    },

    reject (processSlug) {
      return axios.put(`/v1/processes/${processSlug}/candidate-reject`)
    },

    archive (processSlug) {
      return axios.put(`/v1/processes/${processSlug}/candidate-archive`)
    },

    list (profileSlug, page = 1, perPage = 20, archived = false, keyword = '') {
      archived = +archived
      return axios.get(`/v1/processes/profiles/${profileSlug}`, {
        params: {
          page,
          per_page: perPage,
          archived,
          keywords: keyword ? [keyword] : undefined
        }
      })
    }
  },

  vacancy: {
    collapsed (processSlug) {
      return axios.get(`/v1/processes/${processSlug}/vacancy/view/collapse`)
    }
  },

  company: {
    public: {
      accept (processSlug, vacancySlug, profileSlug, payload) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/company-accept`, payload)
      },

      reject (processSlug, vacancySlug, profileSlug, payload) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/company-reject`, payload)
      },

      reply (processSlug, vacancySlug, profileSlug, payload) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/company-reply`, payload)
      },

      sendFeedback (processSlug, vacancySlug, profileSlug, payload) {
        return axios.post(`/v1/processes/${processSlug}/${vacancySlug}/${profileSlug}/public/companies/chats/messages`, payload)
      }
    }
  },

  chat: {
    get (processSlug) {
      return axios.get(`/v1/processes/${processSlug}/chat_rooms`)
    },
    talent (room) {
      return axios.get(`/v1/processes/chat/${room}/talent`)
    },
    crm (room) {
      return axios.get(`/v1/processes/chat/${room}/crm`)
    }
  },

  activity: {
    get (process, cursor = null) {
      return axios.get(
        `/v1/processes/${process}/activities`,
        {
          params: {
            cursor: cursor || undefined
          },
          useStringifyParams: true,
          arrayFormat: 'repeat'
        }
      )
    }
  },

  notes: {
    get (process) {
      return axios.get(`/v1/processes/${process}/notes`)
    },
    create (slug, note) {
      return axios.post(`/v1/processes/${slug}/notes`, note)
    },
    pin (slug, note) {
      return axios.put(`/v1/processes/${slug}/notes/${note}/pin`)
    }
  },

  calendarEvents: {
    get (process) {
      return axios.get(`/v1/processes/${process}/calendar-events`)
    },
    list (from, to) {
      return axios.get('/v1/calendar-events', {
        params: {
          date_from: from,
          date_to: to
        }
      })
    },
    create (slug, calendarEvent) {
      return axios.post(`/v1/processes/${slug}/calendar-events`, calendarEvent)
    },
    aggregatesByDay (from, to) {
      return axios.get('/v1/calendar-events/aggregates/by-day', {
        params: {
          date_from: from,
          date_to: to
        }
      })
    },
    detail: {
      process (slug) {
        return axios.get(`/v1/calendar-events/${slug}/process`)
      }
    }
  },

  attachments: {
    list (slug) {
      return axios.get(`/v1/processes/${slug}/attachments`)
    }
  },

  async download (slug, name) {
    const { data } = await axios({
      url: `/v1/processes/${slug}/download`,
      method: 'GET',
      responseType: 'blob'
    })
    download(data, `${name}.zip`)
  },

  getCoverLetterData (slug, auth, system, locale) {
    const url = `/v1/processes/${slug}/public/cover-letter`

    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${auth}`,
        XSystemType: system,
        'X-locale': locale,
        common: {},
        cacheDuration: 300
      },
      params: {
        base64: true
      }
    })
  },

  profits: {
    update (processSlug, profitSlug, payload) {
      return axios.put(`/v1/processes/${processSlug}/profits/${profitSlug}`, payload)
    }
  },

  responsible: {
    update (processSlug, payload) {
      const responsibleSlug = payload.responsible.slug
      return axios.put(`/v1/processes/${processSlug}/responsible/${responsibleSlug}`)
    }
  }
})
